import React from 'react'

const Footer=()=> {
  return (
    <div className='footer fixed-bottom'>Face-prep @ 2023</div>
  )
}

export default Footer;